import {Plugin, registerPlugin} from "./Plugin";
import {runSafe} from "../utils";
import {OneTimeCode} from "../components/OneTimeCode";

class OneTimeCodePlugin extends Plugin {
  public init(element: Element) {
    runSafe(() => {
      const oneTimeCodes = element.querySelectorAll(".one-time-code");
      for (const oneTimeCode of oneTimeCodes) {
        if (oneTimeCode instanceof HTMLElement) {
          new OneTimeCode(".js-otc-char-inputs", ".js-otc-input");
        }
      }
    });
  }
}

registerPlugin(OneTimeCodePlugin);